import { Navigate, Route, Routes } from "react-router";

import { ProtectedRoute } from "@/components/protected-route";
import { AccessPage } from "@/features/access";
import { AdminPage } from "@/features/admin";
import { FlagsPage } from "@/features/flags";
import { HelpPage } from "@/features/help";
import { GlossaryHelpPage } from "@/features/help/glossary";
import { LeaversHelpPage } from "@/features/help/leavers";
import { OrgHelpPage } from "@/features/help/org";
import { RiskHelpPage } from "@/features/help/risk";
import { RolesHelpPage } from "@/features/help/roles";
import { WorkforceHelpPage } from "@/features/help/workforce";
import { LeaverPage } from "@/features/leaver";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { OrgPage } from "@/features/org";
import { QueuePage } from "@/features/queue";
import { WorkforcePage } from "@/features/workforce";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/queue" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/queue" element={<QueuePage />} />
        <Route path="/leaver" element={<LeaverPage />} />
        <Route path="/leaver/:id" element={<LeaverPage />} />
        <Route path="/flags" element={<FlagsPage />} />
        <Route path="/access" element={<AccessPage />} />
        <Route path="/org" element={<OrgPage />} />
        <Route path="/workforce" element={<WorkforcePage />} />
        <Route path="/workforce/:id" element={<WorkforcePage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/help/roles" element={<RolesHelpPage />} />
        <Route path="/help/leavers" element={<LeaversHelpPage />} />
        <Route path="/help/risk" element={<RiskHelpPage />} />
        <Route path="/help/org" element={<OrgHelpPage />} />
        <Route path="/help/workforce" element={<WorkforceHelpPage />} />
        <Route path="/help/glossary" element={<GlossaryHelpPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
